'use client';
import { Link01 } from '@ethsign/icons';
import { Button, Modal } from '@ethsign/ui';
import classNames from 'classnames';
import { UserPlus } from 'lucide-react';
import React, { useState } from 'react';

import { SendType } from '@/types';

import { CheckBigIcon, CircleIcon } from '../Icons';
type Props = {
  onOpenChange: (open: boolean) => void;
  open: boolean;
  onConfirm: (type: SendType) => void;
};

const CheckItem = ({
  title,
  description,
  checked,
  className,
  onClick,
  Icon
}: {
  title: string;
  description: string;
  checked: boolean;
  className?: string;
  onClick: () => void;
  Icon: any;
}) => {
  return (
    <div
      className={classNames('cursor-pointer p-4 border-gray-200 border rounded-lg bg flex-1 relative ' + className, {
        'border-primary-600': checked,
        'bg-primary-50': checked
      })}
      onClick={() => onClick()}
    >
      <Icon size={32} color={checked ? '#CF5C10' : '#344054'} />
      <div className="mt-3 text-sm font-medium text-gray-700">{title}</div>
      <div className="mt-1 text-sm font-normal text-gray-500">{description}</div>
      <div className="absolute top-4 right-4">{checked ? <CheckBigIcon /> : <CircleIcon />}</div>
    </div>
  );
};
export const ContractSendTypeModal = ({ open, onOpenChange, onConfirm }: Props) => {
  const [sendType, setSendType] = useState<SendType>(SendType.invite);
  return (
    <>
      <Modal
        open={open}
        onOpenChange={onOpenChange}
        //hiddenCloseIcon
        maskClosable={false}
        footer={<div></div>}
        className={'sm:w-[712px] max-w-[712px] gap-0'}
      >
        <div className="flex items-center flex-col justify-center p-6">
          <div className="text-[31px]/[42px] font-semiBold text-gray-900 mt-[20px]">
            How do you want to send the contract?
          </div>
          <div className="w-[534px]  text-sm text-gray-500 mt-2  text-left">
            Choose how you want to send your contract. Generating signing links is suitable if you are collecting
            signatures from a number of signers.
          </div>
          <div className="flex flex-row justify-between items-center mt-12">
            <CheckItem
              className="mr-4"
              Icon={UserPlus}
              checked={sendType === SendType.invite}
              title="Invite Signers"
              description=" Fundraising contracts, employment contracts, etc."
              onClick={() => setSendType(SendType.invite)}
            />
            <CheckItem
              Icon={Link01}
              checked={sendType === SendType.link}
              title="Generate Signing Links"
              description="NDAs, Terms of Services, payments, DAO member agreements, etc."
              onClick={() => setSendType(SendType.link)}
            />
          </div>
          <Button size="sm" className="w-[154px] mt-12" onClick={() => onConfirm(sendType)}>
            Continue
          </Button>
        </div>
      </Modal>
    </>
  );
};
